import _ from 'lodash';
import { action, computed, makeObservable, observable } from 'mobx';

class AsyncObject {
  loaded = false;
  pending = false;
  isError = false;
  errorMessage = '';
  data = null;

  constructor() {
    makeObservable(this, {
      pending: observable,
      loaded: observable,
      isError: observable,
      errorMessage: observable,
      data: observable,
      setError: action,
      resetError: action,
      reset: action,
      isEmpty: computed,
    });
  }

  get isEmpty() {
    return _.isNil(this.data) || _.isEmpty(this.data);
  }

  setData = (data) => {
    this.data = data;
    this.loaded = true;
    this.pending = false;
  };

  setError = (message) => {
    this.loaded = true;
    this.pending = false;
    this.isError = true;
    this.errorMessage = message;
  };

  resetError = () => {
    this.isError = false;
  };

  reset = () => {
    this.loaded = false;
    this.pending = false;
    this.isError = false;
    this.errorMessage = '';
    this.data = null;
  };
}

export default AsyncObject;
